/**
 * Department Service — hits AMC backend (EF Core + Postgres amc schema).
 */

import { apiFetch } from './api';

/** @returns {Promise<Array<{id:string, name:string, createdAt:string, workflowCount:number, memberCount:number}>>} */
export async function fetchDepartments() {
  return apiFetch('/api/departments');
}

export async function createDepartment(name) {
  return apiFetch('/api/departments', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export async function updateDepartment(id, { name }) {
  await apiFetch(`/api/departments/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ name }),
  });
  return { id, name };
}

export async function deleteDepartment(id) {
  await apiFetch(`/api/departments/${id}`, { method: 'DELETE' });
}

/**
 * Map of workflowId → departmentId for all AFD workflows that have an assignment.
 * Client joins this with the workflows list from FD to derive per-workflow departmentId.
 * @returns {Promise<Record<string, string>>}
 */
export async function fetchWorkflowAssignments() {
  return apiFetch('/api/workflow-departments');
}

export async function assignWorkflowDepartment(workflowId, deptId) {
  if (deptId) {
    await apiFetch(`/api/workflow-departments/${encodeURIComponent(workflowId)}`, {
      method: 'PUT',
      body: JSON.stringify({ departmentId: deptId }),
    });
  } else {
    await apiFetch(`/api/workflow-departments/${encodeURIComponent(workflowId)}`, {
      method: 'DELETE',
    });
  }
}
